import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "../../translation";
import NotFoundMessage from "../NotFoundMessage";
import ShopWomenAndMen from "../../ShopWomenAndMen";

// TODO: remove this page - I don't even think this page gets used anymore.
// The responsibility for this component now lives with: https://www.asos.com/discover/no-results-page/?WT.oss=blablablabalabaa
const NoResults = ({ searchTerm = "", formatTranslation, formatLink }) => (
  <div data-auto-id="noResultsMessage">
    <NotFoundMessage
      errorMessage={formatTranslation("plp_web_search_error_message", {
        searchTerm
      })}
      suggestionMessage={formatTranslation("plp_web_search_suggestion_message")}
    />
    <ShopWomenAndMen
      shopWomenLink={formatLink("")}
      shopWomenMessage={formatTranslation("plp_web_search_shop_women")}
      shopMenLink={formatLink("")}
      shopMenMessage={formatTranslation("plp_web_search_shop_men")}
    />
  </div>
);

NoResults.propTypes = {
  searchTerm: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired,
  formatLink: PropTypes.func.isRequired
};

NoResults.displayName = "NoResults";

export default withTranslation(NoResults);
